export const state = () => ({
  page: 0,
  agreements: [],
  filters: '',
  resultCount: 0,
});

export const getters = {
  getData(store) {
    return store.agreements;
  },
  getPage(store) {
    return store.page;
  },
  getFilters(store) {
    return store.filters;
  },
  getResultCount(store) {
    return store.resultCount;
  },
};

export const mutations = {
  reset(store) {
    store.page = 0;
    store.agreements = [];
    store.filters = '';
    store.resultCount = 0;
  },
  setAgreements(store, payload) {
    store.agreements = payload;
  },
  clearAgreements(store) {
    store.agreements = [];
  },
  setPage(store, payload) {
    store.page = payload;
  },
  setFilters(store, payload) {
    store.filters = payload;
  },
  setResultCount(store, payload) {
    store.resultCount = payload;
  },
};

export const actions = {
  async reset({ commit }) {
    commit('reset');
  },
  async fetchData({ commit, state }) {
    let url = 'consolidated_arrears';
    if (state.page) {
      url += `&page=${state.page}`;
    }
    if (state.filters) {
      url += state.filters;
    }

    const consolidated_agreements = await this.$axios.$get(url);

    commit('setAgreements', consolidated_agreements.agreement_list);
    commit('setResultCount', consolidated_agreements.total);
  },

  async clearAgreements({ commit }) {
    commit('clearAgreements');
  },
  async setPage({ commit }, payload) {
    commit('setPage', payload);
  },
  async setFilters({ commit }, payload) {
    commit('setFilters', payload);
  },
};
